module.exports = __webpack_public_path__ + "bb21e80f2920db439d604e956bcdcf3f.png";